import { min, parseISO } from 'date-fns'

import type { TSimulacaoCalculoPrazo } from '@/domain/simulador/factories/types/simulacao-calculo'
import { CalculadorPrazoBase as CalculadorPrazoBaseShared } from '@/features/simulador/shared/domain/calculador-prazo-base'
import {
  extraiDataPosConclusao,
  extraiDataSaldo,
  extraiDatasEntradas,
  extraiDatasIntermediarias,
  extraiDatasMensais,
} from '@/features/simulador/shared/domain/extratores-de-datas'
import { maxDate } from '@/utils/date.utils'

export class CalculadorPrazoBase extends CalculadorPrazoBaseShared<TSimulacaoCalculoPrazo> {
  constructor(grupos: TSimulacaoCalculoPrazo) {
    super(grupos, [
      extraiDatasEntradas(),
      extraiDatasIntermediarias(),
      extraiDatasMensais(),
      extraiDataSaldo(),
      extraiDataPosConclusao(),
    ])
  }

  protected getDataPrimeiraEntrada(): Date | null {
    const datasEntradas = this.grupos.entradas?.map((entrada) => entrada.data).filter((data) => data !== null)
    if (!datasEntradas?.length) return null
    return min(datasEntradas.map((data) => parseISO(data)))
  }

  protected getDataUltimaMensalOuIntermediaria(): Date | null {
    const datasMensais = this.grupos.mensais?.map((mensal) => mensal.dataFim).filter((data) => data !== null) ?? []
    const datasIntermediarias =
      this.grupos.intermediarias?.flatMap((grupo) =>
        grupo.parcelas.map((parcela) => parcela.data).filter((data) => data !== null),
      ) ?? []

    const todasAsDatas = [...datasMensais, ...datasIntermediarias]

    if (!todasAsDatas.length) return null
    return maxDate(todasAsDatas.map((data) => parseISO(data)))
  }
}
